import { render, staticRenderFns } from "./EditScore.vue?vue&type=template&id=432809b6&"
import script from "./EditScore.vue?vue&type=script&lang=ts&"
export * from "./EditScore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports